<template>
  <div>
    <div :class="$style.box" :style="{backgroundImage: `url(${bg})`}">
      <!-- 表单验证 -->
      <div :class="$style.bind">
        <img :src="backIcon" alt="" v-if="method != 2" @click="method = 2" :class="$style.back">
        <p :class="$style.title">{{ method ? (method == 1 ? '手机号绑定' : '绑定码一键绑定') : '账号绑定' }}</p>
        <Field
          :class="$style.field"
          v-model.trim="tempId"
          :type="1"
          :pic="accIcon"
          placeHolder="请输入您的绑定码"
          v-show="method == 2"
        ></Field>
        <Field
          :class="$style.field"
          v-model.trim="formData.acc"
          :type="1"
          :pic="accIcon"
          :placeHolder="accPlaceHolder"
          v-show="!method"
        ></Field>
        <Field
          :class="$style.field"
          v-model.trim="formData.pass"
          :type="1"
          :pic="passIcon"
          :placeHolder="passPlaceHolder"
          :inputType="'password'"
          v-show="!method"
        ></Field>
        <Field
          :class="$style.field"
          v-model.trim="cellFormData.tel_num"
          :type="1"
          :pic="`${CDN_URL}/packet/cell.png`"
          placeHolder="请输入手机号"
          v-show="method == 1"
        ></Field>
        <div :class="$style.formItem" v-show="method == 1">
          <img :src="`${CDN_URL}/packet/pass_01.png`" alt="">
          <VField
            :class="$style.codeField"
            v-model.trim="cellFormData.code"
            placeholder="请输入验证码"
          >
            <template v-slot:right-icon>
              <Button plain type="info" :class="$style.verifyCode" v-if="!count" @click="getCode">获取</Button>
              <span v-else>{{count}}s</span>
            </template>
          </VField>
        </div>
        <div :class="$style.redirect" v-if="method == 2">
          <span @click="switchMethod(0)">使用账号密码绑定</span>
          <span @click="switchMethod(1)">使用手机号绑定</span>
        </div>
        <div :class="$style.sure" @click="submit">确认绑定</div>
      </div>
      <div :class="$style.bind" v-if="bindSuccessFlag">
        <p>账号信息</p>
        <p :class="$style.red">账号绑定成功!</p>
        <p :class="$style.text">请耐心等待</p>
        <p :class="$style.text">系统正在为您审核中</p>
        <p :class="$style.text">预计<span>三小时</span>左右哦~</p>
      </div>
    </div>
  </div>
</template>

<script>
import CryptoJS from "crypto-js";
import Field from "@/components/Field.vue";
import CountDown from "@/mixins/countDown";
import { cellBindVerify, cellBind, tempIdBind } from "@/apis/sdkhb";
import { CDN_URL } from "@/config";
import { Toast, Field as VField } from "vant";
import { sort_ASCII } from "@/libs/utils";
import { mapState, mapActions, mapMutations } from "vuex";
import { regexpVerify } from "@/libs/account";

export default {
  data() {
    return {
      name: "绑定账号",
      accIcon: `${CDN_URL}/packet/acc_01.png`, // 账号icon
      accPlaceHolder: "请输入您的账号",
      backIcon: `${CDN_URL}/back.png`,
      passIcon: `${CDN_URL}/packet/pass_01.png`, // 密码icon
      bg: `${CDN_URL}/packet/bg3.jpg?v=3`,
      passPlaceHolder: "请输入您的密码",
      formData: {
        acc: "",
        pass: ""
      },
      CDN_URL,
      cellFormData: {
        tel_num: "",
        code: ""
      },
      bindSuccessFlag: false,
      method: 2, // 0. 账号登陆 1.手机号登录 2.tempId绑定
      code: "",
      tempId: ''
    };
  },
  mixins: [CountDown],
  mounted() {
  },
  components: {
    Field,
    VField
  },
  computed: {
    ...mapState("sdkhb", {
      userInfo: "userInfo"
    })
  },
  methods: {
    ...mapActions("sdkhb", {
      userBind: "userBind"
    }),
    ...mapMutations("sdkhb", {
      CHANGE_USERINFO: "CHANGE_USERINFO"
    }),
    switchMethod(type) {
      if (type) {
        this.method = type;
        return;
      }
      this.method = this.method ? 0 : 1
    },
    async submit() {
      if (this.method == 2) {
        this.tempIdSubmit();
        return;
      }
      if (this.method === 1) {
        this.cellSubmit();
        return;
      }
      if (!this.formData.acc) {
        Toast("账号不能为空", 2000);
        return;
      }
      if (!this.formData.pass) {
        Toast("密码不能为空", 2000);
        return;
      }
      // 用户登录
      const pass = CryptoJS.MD5(this.formData.pass)
        .toString()
        .toLowerCase();
      const data = {
        user_name: this.formData.acc,
        password: CryptoJS.MD5(this.formData.pass + pass)
          .toString()
          .toLowerCase(),
        open_id: this.userInfo.open_id
      };
      const r = await this.userBind({
        ...data,
        sign: sort_ASCII(data)
      });
      if (r.ret === 1) {
        console.log("login bind", this.userInfo);
        this.CHANGE_USERINFO({ userInfo: r.content });
        this.bindSuccessFlag = true;
        setTimeout(() => {
          this.$router.replace({ name: this.$route.name == 'sdkhb-login' ? "sdkhb-role" : 'sdkhb-wxRole' });     
        }, 3000);
      }
      return;
    },
    async getCode() {
      if (!this.cellFormData.tel_num) {
        Toast('手机号不能为空')
        return;
      }
      await regexpVerify(this.cellFormData, [
        { key: "tel_num", type: "phone", hint: "请输入正确的手机号" },
      ]);
      const time = Math.ceil((new Date().getTime())/1000)
      const sign = CryptoJS.MD5(CryptoJS.MD5("unknown"+ time + this.cellFormData.tel_num) + "unknown"+ time + this.cellFormData.tel_num).toString();
      await cellBindVerify({
        tel_num: this.cellFormData.tel_num,
        device_id: "unknown",
        time,
        sign
      });
      this.setTimer();
    },
    async cellSubmit() {
      if (!this.cellFormData.tel_num) {
        Toast("手机号不能为空", 2000);
        return;
      }
      if (!this.cellFormData.code) {
        Toast("验证码", 2000);
        return;
      }
      const data = {
        tel_num: this.cellFormData.tel_num,
        code: this.cellFormData.code,
        open_id: this.userInfo.open_id,
      }
      const r = await cellBind({
        ...data,
        sign: sort_ASCII(data)
      });
      if (r.ret === 1) {
        console.log("login bind", this.userInfo);
        this.CHANGE_USERINFO({ userInfo: r.content });
        this.bindSuccessFlag = true;
        setTimeout(() => {
          this.$router.replace({ name: this.$route.name == 'sdkhb-login' ? "sdkhb-role" : 'sdkhb-wxRole' });     
        }, 3000);
      }
    },
    async tempIdSubmit() {
      const data = {
        temp_id: this.tempId,
        open_id: this.userInfo.open_id,
      }
      const r = await tempIdBind({
        ...data,
        sign: sort_ASCII(data)
      })
      if (r.ret === 1) {
        console.log("login bind", this.userInfo);
        this.CHANGE_USERINFO({ userInfo: r.content });
        this.bindSuccessFlag = true;
        setTimeout(() => {
          this.$router.replace({ name: this.$route.name == 'sdkhb-login' ? "sdkhb-role" : 'sdkhb-wxRole' });     
        }, 3000);
      }
    }
  }
};
</script>

<style lang="scss" module>
.box {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: black;
  background-size: 100%;
  background-repeat: no-repeat;
  .bind {
    width: 300px;
    height: 240px;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 10px;
    position: absolute;
    top: 180px;
    left: 50%;
    display: block;
    margin-left: -150px;
    box-sizing: content-box;
    .title {
      margin-bottom: 24px;
    }
    .back {
      position: absolute;
      top: 5px;
      left: 10px;
      width: 20px;
    }
    > p {
      width: 100%;
      text-align: center;
      line-height: 30px;
      font-size: 16px;
    }
    .field {
      margin-top: 14px;
      margin-left: 50%;
      transform: translateX(-113px);
    }
    .formItem {
      display: flex;
      background: rgba(241, 241, 241, 1);
      margin-top: 14px;
      margin-left: 50%;
      transform: translateX(-113px);
      width: 226px;
      height: 45px;
      align-items: center;
      border-radius: 9px;
      :global {
        .van-field__control {
          font-size: 15px;
        }
      }
      > img {
        width: 15px;
        // height: 20px;
        margin-left: 14px;
        margin-right: 10px;
      }
      .verifyCode {
        padding: 0;
        border: none;
        color: #399fff;
      }
    }
    .codeField {
      background: rgba(241, 241, 241, 1);
      border-radius: 9px;
      :global {
        .van-field__control {
          &::-webkit-input-placeholder {
            color: #c0c0c0;
            line-height: 24px;
          }
        }
      }
    }
    .switchMethod {
      margin-top: 15px;
      text-align: center;
      color: #399fff;
    }
    .sure {
      width: 226px;
      height: 42px;
      background: #399fff;
      border-radius: 9px;
      line-height: 42px;
      text-align: center;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      margin-left: 50%;
      transform: translateX(-113px);
      margin-top: 30px;
    }
    .red {
      color: red;
      font-size: 20px;
      margin: 40px 0 5px;
    }
    .text {
      font-size: 12px;
      > span {
        color: red;
      }
    }
    .redirect {
      display: flex;
      color: #399fff;
      justify-content: space-between;
      padding: 25px 20px 10px;
    }
  }
}
</style>